'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.networkOnline = exports.networkOffline = exports.receivedStatusUpdate = exports.receivedSubscribeConfirmation = exports.CATEGORIES_TO_LOG = undefined;
exports.receivedPubNubStatus = receivedPubNubStatus;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _underscore = require('underscore');

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _PubNubStatusCategories = require('conversations-core/constants/PubNubStatusCategories');

var PubNubStatusCategories = _interopRequireWildcard(_PubNubStatusCategories);

var _utils = require('ReduxMessenger/utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CATEGORIES_TO_LOG = exports.CATEGORIES_TO_LOG = ['PNDecryptionErrorCategory', 'PNBadRequestCategory', 'PNMalformedResponseCategory', 'PNAccessDeniedCategory', 'PNTimeoutCategory', 'PNNetworkIssuesCategory'];

var receivedSubscribeConfirmation = exports.receivedSubscribeConfirmation = (0, _reduxActions.createAction)(_ActionTypes2.default.SUBSCRIBE_CONFIRMATION);

var receivedStatusUpdate = exports.receivedStatusUpdate = (0, _reduxActions.createAction)(_ActionTypes2.default.RECEIVED_PUBNUB_STATUS);

function receivedPubNubStatus(statusEvent) {
  return function (dispatch) {
    if (statusEvent.category === PubNubStatusCategories.CONNECTED) {
      dispatch(receivedSubscribeConfirmation(statusEvent.affectedChannels));
    } else if ((0, _underscore.contains)(CATEGORIES_TO_LOG, statusEvent.category)) {
      window.Raven.captureMessage('PUBNUB_STATUS_ERROR', {
        extra: statusEvent
      });
    }
    dispatch(receivedStatusUpdate(statusEvent));
  };
}

var networkOffline = exports.networkOffline = (0, _reduxActions.createAction)(_ActionTypes2.default.NETWORK_OFFLINE);
var networkOnline = exports.networkOnline = (0, _reduxActions.createAction)(_ActionTypes2.default.NETWORK_ONLINE, function () {}, function () {
  return {
    notification: (0, _utils.createSuccessNotification)(_I18n2.default.text('alerts.pubNubStatus.PNNetworkUpCategory.title'), _I18n2.default.text('alerts.pubNubStatus.PNNetworkUpCategory.description'), false)
  };
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/actions/PubNubStatusActions.js
// module id = 271
// module chunks = 0